import type { Api } from '@subaio/utils'

import type { UserAuth } from 'lib/store'
import { isB2C } from 'lib/userAuth'

import { Logo } from 'components/Logo'

import { AlignmentWrapper } from './AlignmentWrapper'
import { Container } from './Container'
import { Content } from './Content'
import { Title } from './Title'
import { UserMenu } from './UserMenu'

type Props = {
	api: Api
	onLogout: () => void
	userAuth: UserAuth
}

export const Header = ({ api, onLogout, userAuth }: Props) => (
	<Container>
		<Content>
			<AlignmentWrapper align='left'>
				<Logo type='secondary' size={52} />
				<Title>Finance Data</Title>
			</AlignmentWrapper>
			{userAuth.status === 'authenticated' && (
				<AlignmentWrapper align='right'>
					<UserMenu api={api} onLogout={onLogout} isB2C={isB2C(userAuth.user.token)} />
				</AlignmentWrapper>
			)}
		</Content>
	</Container>
)
